export const BIZ = {
  name: "Artha Insurance LLC",
  address: "12800 WestRidge Blvd, Ste 271, Frisco, Texas 75035",
  addressShort: "12800 WestRidge Blvd, Ste 271, Frisco, TX",
  phone: "(469) 815-3491",
  phoneHref: "tel:+14698153491",
  email: "info@arthainsurance.com",
  emailHref: "mailto:info@arthainsurance.com",
  hours: "Monday to Friday, 8:30 to 5:30 Central",
  npnAgency: "22254975",
  npnIndividual: "22250458",
  agent: "Sreenivas Palla",
  effectiveDate: "September 8, 2026",
};

export const BINDING_NOTICE =
  "Notice: Submitting a request does not bind, activate, or alter insurance coverage. An authorized agent will contact you to verify details and finalize your policy.";

export const TCPA_TEXT =
  "I agree that Artha Insurance LLC may contact me by phone, text message, or email — including at a wireless number I provide — about my request and related insurance services. Consent is not a condition of purchase, and I can reply STOP to any text to opt out. See our";

export const FAQS = [
  {
    q: "Does it cost more to buy through an agency?",
    a: "No. Rates are filed with the state by the carrier, so the premium is the same whether you buy direct or through us. Our commission comes out of the carrier's side.",
  },
  {
    q: "What do you need from me to quote?",
    a: "For a business: your current declarations page, annual revenue, payroll, and a description of what you do. For a home or car: the address, the declarations page, and the drivers or occupants. If you don't have a current policy, we'll walk through it on a call.",
  },
  {
    q: "Where do I pay my premium?",
    a: "Directly to whichever carrier issued your policy — we don't take card payments for premium. Your billing statement has the portal link, and if you can't find it, tell us your carrier and we'll send it to you.",
  },
  {
    q: "How fast can I get a certificate of insurance?",
    a: "Usually same business day when the request comes in before mid-afternoon and no special endorsement is needed. Additional insured or waiver of subrogation wording sometimes needs carrier sign-off, which adds a day.",
  },
  {
    q: "Do you handle personal and business for the same household?",
    a: "Yes, and it's usually worth doing. Coordinating your commercial auto, personal auto, and umbrella through one agency avoids the gap where each insurer points at the other after an accident.",
  },
];

export const PORTAL_POLICIES = [
  { line: "Business owner's policy", number: "BOP-4821-0093", carrier: "Sample Carrier", term: "04/01/2026 – 04/01/2027", premium: "$2,412 / yr", status: "Active" },
  { line: "Commercial auto", number: "CA-7710-4415", carrier: "Sample Carrier", term: "04/01/2026 – 04/01/2027", premium: "$3,860 / yr", status: "Active" },
  { line: "Homeowners", number: "HO-2280-6634", carrier: "Sample Carrier", term: "07/15/2026 – 07/15/2027", premium: "$2,975 / yr", status: "Active" },
  { line: "Personal umbrella", number: "PU-0921-1108", carrier: "Sample Carrier", term: "07/15/2026 – 07/15/2027", premium: "$385 / yr", status: "Renewal offered" },
];

export const PORTAL_DOCUMENTS = [
  { name: "BOP declarations page 2026–27.pdf", date: "Apr 1, 2026", type: "Declarations" },
  { name: "Commercial auto ID cards.pdf", date: "Apr 1, 2026", type: "ID cards" },
  { name: "Homeowners policy jacket.pdf", date: "Jul 15, 2026", type: "Policy" },
  { name: "Umbrella renewal offer.pdf", date: "Aug 20, 2026", type: "Renewal" },
];

export const PORTAL_BILLING = [
  { policy: "BOP-4821-0093", due: "Oct 1, 2026", amount: "$201.00", status: "Upcoming" },
  { policy: "CA-7710-4415", due: "Oct 1, 2026", amount: "$321.67", status: "Upcoming" },
  { policy: "HO-2280-6634", due: "Paid in full", amount: "—", status: "Paid" },
];

export const PORTAL_CERTIFICATES = [
  { holder: "Northline Property Group LLC", issued: "Aug 12, 2026", policy: "BOP-4821-0093" },
  { holder: "City of Frisco — Permits", issued: "Jun 3, 2026", policy: "BOP-4821-0093" },
];

export const PORTAL_CLAIMS = [
  { number: "CLM-2026-00418", line: "Commercial auto", opened: "May 9, 2026", status: "Closed — paid", note: "Hail damage, two fleet vehicles" },
];
